define("shared/utils/media-adjustments/group-adjustments", ["exports", "shared/utils/media-adjustments/format-platform-name"], function (_exports, _formatPlatformName) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.combineSimilarViolations = combineSimilarViolations;
  _exports.groupMediaAdjustments = groupMediaAdjustments;
  0; //eaimeta@70e063a35619d71f0,"shared/utils/media-adjustments/format-platform-name"eaimeta@70e063a35619d71f
  const WITHIN_TEN_PERCENT = 0.1;
  function adjustedFingerprint(adjusted) {
    if (!adjusted) {
      return 'none';
    }
    return `${adjusted.width}x${adjusted.height}:${adjusted.format ?? ''}:${adjusted.file_size ?? ''}`;
  }
  function areWithinTenPercent(a, b) {
    const max = Math.max(a, b);
    if (max === 0) {
      return true;
    }
    return Math.abs(a - b) / max <= WITHIN_TEN_PERCENT;
  }
  function moreRestrictiveViolation(left, right) {
    if (typeof left.expected === 'number' && typeof right.expected === 'number') {
      return left.expected <= right.expected ? left : right;
    }
    return left;
  }
  function combineSimilarViolations(violations) {
    const combined = [];
    violations.forEach(violation => {
      const existingIndex = combined.findIndex(existing => {
        if (existing.name !== violation.name) {
          return false;
        }
        if (typeof existing.expected === 'number' && typeof violation.expected === 'number') {
          return areWithinTenPercent(existing.expected, violation.expected);
        }
        return existing.expected === violation.expected && existing.actual === violation.actual;
      });
      if (existingIndex === -1) {
        combined.push(violation);
        return;
      }
      combined[existingIndex] = moreRestrictiveViolation(combined[existingIndex], violation);
    });
    return combined;
  }
  function groupMediaAdjustments(payload) {
    if (!payload?.platforms) {
      return [];
    }
    const entries = Object.entries(payload.platforms).filter(_ref => {
      let [, adjustment] = _ref;
      const {
        violations
      } = adjustment;
      return Array.isArray(violations) && violations.length > 0;
    });
    if (entries.length === 0) {
      return [];
    }
    const groups = [];
    entries.forEach(_ref2 => {
      let [platformKey, adjustment] = _ref2;
      const fingerprint = adjustedFingerprint(adjustment.adjusted);
      const existingGroup = groups.find(group => adjustedFingerprint(group.adjusted) === fingerprint && fingerprint !== 'none');
      if (existingGroup) {
        existingGroup.platformKeys.push(platformKey);
        existingGroup.violations.push(...adjustment.violations);
        return;
      }
      groups.push({
        platformKeys: [platformKey],
        platformDisplayName: (0, _formatPlatformName.formatPlatformName)(platformKey),
        violations: [...adjustment.violations],
        adjusted: adjustment.adjusted,
        preview: adjustment.preview
      });
    });
    return groups.map(group => ({
      ...group,
      platformDisplayName: group.platformKeys.length > 1 ? group.platformKeys.map(_formatPlatformName.formatPlatformName).join(', ') : (0, _formatPlatformName.formatPlatformName)(group.platformKeys[0]),
      violations: combineSimilarViolations(group.violations)
    }));
  }
});